import { useEffect, useState, type ReactNode } from 'react';
import { type SignupResponse } from '@hungryroot/rest';
import { loadAppleSdk, appleAuth, type AppleSdk } from '../../provider/apple';
import { AppleIcon } from '../../svg/AppleIcon';
import { RoundedButton } from '../RoundedButton/RoundedButton';

type Props = {
  onLoginSuccess: (data: SignupResponse) => void;
  onSignupSuccess: (data: SignupResponse) => void;
  onError: () => void;
  /** Marks a freemium (guest-flow) signup if this auth creates an account. */
  isGuestFlow?: boolean;
  children?: ReactNode;
};

export function ButtonApple({
  onLoginSuccess,
  onError,
  onSignupSuccess,
  isGuestFlow,
  children,
}: Props) {
  const [sdk, setSdk] = useState<AppleSdk | null>(null);
  useEffect(() => {
    loadAppleSdk({
      onReady: setSdk,
    });
  }, []);

  return (
    <RoundedButton
      disabled={sdk === null}
      onClick={() => {
        if (sdk === null) {
          return;
        }
        appleAuth({
          appleId: sdk,
          onSignupSuccess,
          onLoginSuccess,
          onError,
          isGuestFlow,
        });
      }}
      aria-label="Sign up with Apple"
    >
      <AppleIcon />
      {children}
    </RoundedButton>
  );
}
